import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { PPI } from '@ikea-food-ux/ppsi';
import { getOverviewLabels } from '../../../features/app/overviewLabelSelectors';
import { getProductions } from '../../../features/app/productionSelectors';
import { getLanguage } from '../../../features/app/selectors';
import { getStockHierarchy } from '../../../features/app/stockHierarchySelectors';
import { getTemperatureUnits } from '../../../features/app/temperatureUnitSelectors';
import { getTimeUnits } from '../../../features/app/timeUnitSelectors';
import { stitchPpi } from '../../../utils/ui2pStitchPPI';
import FormContext from '../../Form/FormContext';
import { getShelfLifeTimeUnitsUnits } from 'features/app/shelfLifeTimeUnitsSelectors';

const OverviewTabContent = () => {
  const { data } = useContext(FormContext);
  const language = useSelector(getLanguage);
  const labels = useSelector(getOverviewLabels).toJS();
  const timeUnits = useSelector(getTimeUnits).toJS();
  const temperatureUnits = useSelector(getTemperatureUnits).toJS();
  const shelfLifeTimeUnits = useSelector(getShelfLifeTimeUnitsUnits).toJS();
  const stockHierarchy = useSelector(getStockHierarchy).toJS();
  const productionOptions = useSelector(getProductions).toJS();
  const ppi = stitchPpi(data);
  const ingredient = ppi.referencedIngredientData;

  return (
    <PPI
      ppi={ppi}
      ingredient={ingredient}
      labels={labels}
      timeUnits={timeUnits}
      temperatureUnits={temperatureUnits}
      stockHierarchy={stockHierarchy}
      productionOptions={productionOptions}
      language={language}
      navigateIcon={null}
      shelfLifeTimeUnits={shelfLifeTimeUnits}
    />
  );
};

export default OverviewTabContent;
